import { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import moment from 'moment';

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <div className="main-wrapper position-relative">
        <Header />
        <div className="main-content-wrapper">
          <Sidebar />
          <div className="main-view-content" id="contentWrapper">
            {children}
          </div>
          <footer className="border-top bg-white py-2  position-fixed bottom-0 start-0 end-0 footer-left">
            <div className="d-flex justify-content-between align-items-center mx-4">
              <p className="m-0">© {moment().year()} iWebwiser</p>
              <div className="d-flex">
                <p className="m-0">version 1.1</p>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};
export default Layout;
